import {useState} from 'react';

const useHover = () => {
  const [hovering, setHovering] = useState(false);

  const handleHoverIn = () => {
    setHovering(true);
  };

  const handleHoverOut = () => {
    setHovering(false);
  };

  return {hovering, handleHoverIn, handleHoverOut};
};

export default useHover;
